module.exports = __webpack_public_path__ + "static/media/loading.4a46862e.svg";